import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "You do not have permission to view this page.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Contact your administrator to activate your account.", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}